import {
  Component,
  DoCheck,
  EventEmitter,
  Input,
  IterableDiffer,
  IterableDiffers,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {PodValidationSearchCriteria} from '../shared/pod-validation-search-criteria.model';
import {DataFiltersComponent} from '../../shared/data-filters/data-filters.component';
import { Option } from '../../shared/data-filters/data-filter-select/data-filter-select.component';
import { PodValidationDeliveryType } from '../shared/pod-validation.model';
import { Carrier } from '../../user-dashboard/shared/carrier.model';

@Component({
  selector: 'app-pods-validation-filters',
  templateUrl: './pods-validation-filters.component.html',
  styleUrls: ['./pods-validation-filters.component.scss']
})
export class PodsValidationFiltersComponent implements OnInit, DoCheck {

  @ViewChild('dataFilters', { static: true }) private filtersComponent: DataFiltersComponent;

  @Input() public filters: PodValidationSearchCriteria;
  @Input() public displaySendReminderButton: boolean;
  @Input() public displayExportButton: boolean;
  @Input() public originOptions: Option[] = [];
  @Input() public isCarrier = false;
  @Input() public allCarriers: Carrier[] = [];
  @Input() public availableCarriers: Option[] = [];
  @Input() public availableRegions: Option[] = [];
  @Input() public disableSearch: boolean;

  @Output() public search: EventEmitter<void> = new EventEmitter<void>();
  @Output() public reset: EventEmitter<void> = new EventEmitter<void>();
  @Output() public sendReminder: EventEmitter<void> = new EventEmitter<void>();
  @Output() public export: EventEmitter<void> = new EventEmitter<void>();
  @Output() public filtersChange: EventEmitter<PodValidationSearchCriteria> = new EventEmitter<PodValidationSearchCriteria>();
  @Output() public regionsChange: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() public carriersChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  public typeOptions: Option[] = [
    { labelKey: 'pods-validation.filters.all' , value: null },
    { labelKey: 'pods-validation.tabs.item.type.manufacturer', value: PodValidationDeliveryType.MANUFACTURER },
    { labelKey: 'pods-validation.tabs.item.type.mr', value: PodValidationDeliveryType.MR }
  ]

  regionsDiffer: IterableDiffer<string>;
  carriersDiffer: IterableDiffer<string>;
  originGlidDiffer: IterableDiffer<string>;
  destinationGlidDiffer: IterableDiffer<string>;

  constructor(
    private iterableDiffers: IterableDiffers,
  ) {
    this.regionsDiffer = iterableDiffers.find([]).create(null);
    this.carriersDiffer = iterableDiffers.find([]).create(null);
    this.originGlidDiffer = iterableDiffers.find([]).create(null);
    this.destinationGlidDiffer = iterableDiffers.find([]).create(null);
  }

  public ngOnInit(): void {
    if (this.filtersComponent) {
      this.filtersComponent.getResetObservable().subscribe(() => this.reset.emit());
      this.filtersComponent.getApplyObservable().subscribe(() => this.search.emit());
    }
    if (this.isCarrier) {
      this.search.emit();
    }
  }

  public ngDoCheck() {
    if (!!this.regionsDiffer.diff(this.filters.regions)) {
      this.filters.regions = [...this.filters.regions];
    }
    if (!!this.carriersDiffer.diff(this.filters.carriers)) {
      this.filters.carriers = [...this.filters.carriers];
    }
    if (!!this.originGlidDiffer.diff(this.filters.originGlid)) {
      this.filters.originGlid = [...this.filters.originGlid];
    }
    if (!!this.destinationGlidDiffer.diff(this.filters.destinationGlid)) {
      this.filters.destinationGlid = [...this.filters.destinationGlid];
    }
  }

  public filtersChanged(): void {
    this.filtersChange.emit(this.filters);
  }

  public regionsChanged(): void {
    this.regionsChange.emit(this.filters.regions);
    this.filtersChange.emit(this.filters);
  }

  public carrierChanged(): void {
    this.carriersChange.emit(this.filters.carriers);
    this.filtersChange.emit(this.filters);
  }
}

